import { render, staticRenderFns } from "./TargetPageHeader.vue?vue&type=template&id=754c0ce5&scoped=true"
import script from "./TargetPageHeader.vue?vue&type=script&lang=js"
export * from "./TargetPageHeader.vue?vue&type=script&lang=js"
import style0 from "./TargetPageHeader.vue?vue&type=style&index=0&id=754c0ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754c0ce5",
  null
  
)

export default component.exports